// extracted by mini-css-extract-plugin
export var h1 = "typography-module--h1--Xy3YQ";
export var h2 = "typography-module--h2--2g__2";
export var h3 = "typography-module--h3--4zxyT";
export var h4 = "typography-module--h4--hVh7e";
export var body1 = "typography-module--body1--1vqxY";
export var body2 = "typography-module--body2--qtHme";
export var body3 = "typography-module--body3--3xfzl";
export var button = "typography-module--button--2O-lc";